/*
 * @Description: 客户案例页面所有路由
 * @Author: 任录
 * @Date: 2019-07-22 16:50:00
 * @LastEditTime: 2021-09-02 10:53:55
*/

export default [
  {
    path: 'servicesAndSupport',
    component: resolve => require(['@/views/servicesAndSupport'], resolve),
    name: 'ServicesAndSupport',
    meta: {
      title: '服务与支持'
    }
  },
  {
    path: 'customer/:id',
    component: resolve => require(['@/views/customer'], resolve),
    name: 'Customer',
    meta: {
      title: '客户案例',
      guidePath: true,
      jumpPath: '/'
    }
  }
    
]


// WEBPACK FOOTER //
// ./src/router/customer.js